import {getSimpleMonthDayHoursMinutesFromISOString} from './dateFunctions';


export function arrayFunctionForTypeRangeGraph(origTypeReadings, origType, intervalMinutes, fromDate, toDate) {
    const readingArray = createIncrementedArrayForRange(origType, intervalMinutes, fromDate, toDate);
    const delay = addDelay(origType, intervalMinutes);
    drawAllReadingsOnGraph(origTypeReadings, origType, delay, readingArray, intervalMinutes, fromDate, toDate);
    return readingArray;
}

/** NOT EXPORTED FUNCTIONS **/

function drawAllReadingsOnGraph(origTypeReadings, origType, delay, readingArray, intervalMinutes, fromDate, toDate) {
    let valueToSearch = '';
    let foundIndex = 0;
    let readingAmount = 0;
    let halflifeArray = [];
    origTypeReadings.length > 0 && readingArray.length > 0 && origTypeReadings.forEach((reading) => {
        valueToSearch = getSimpleMonthDayHoursMinutesFromISOString(reading.dateTime, intervalMinutes);
        foundIndex = readingArray.findIndex(elem => elem.dateTime === valueToSearch);
        if (foundIndex !== -1 && reading.typeId === origType._id) {
            if (origType.reductionHalflife > 0) {
                readingAmount = reading.activeAmount;
                halflifeArray = createIncrementedArrayForRange(origType, intervalMinutes, fromDate, toDate, readingAmount);
            } else {
                readingArray[foundIndex][origType.name] += reading.activeAmount;
            }
        }
        if (origType.reductionHalflife > 0) {
            halflife(foundIndex, halflifeArray, origType, delay, readingAmount, readingArray, intervalMinutes);
        }
    });

    if (origType.reductionPerHour > 0) {
        perHour(origType, readingArray, delay, intervalMinutes);
    }
}

function halflife(foundIndex, halflifeArray, origType, delay, readingAmount, readingArray, intervalMinutes) {
    let reduced = 0;
    if (foundIndex !== -1) {
        for (let i = foundIndex; i < halflifeArray.length; i++) {
            if (halflifeArray.length > 0) {
                halflifeArray[i][origType.name] = readingAmount;
                reduced = halflifeReduction(origType, foundIndex, i, delay, readingAmount, halflifeArray, intervalMinutes);
                halflifeArray[i][origType.name] -= reduced;
                readingArray[i][origType.name] += halflifeArray[i][origType.name];
            }
        }
    } else {
        console.log('foundIndex: ', foundIndex);
        console.log('readingAmount: ', readingAmount);
    }
}

function halflifeReduction(origType, foundIndex, i, delay, readingAmount, halflifeArray, intervalMinutes) {
    const increments = Math.round(origType.reductionHalflife / intervalMinutes);
    let reduced = 0;
    if (i > (foundIndex + delay)) {
        let whichIteration = Math.ceil((i - foundIndex - delay) / increments) - 1;
        let startingAmount = halflifeArray[foundIndex + delay + (increments * whichIteration)][origType.name];
        let halflifeReduction = startingAmount / 2;
        let alreadyReduced = readingAmount - startingAmount;
        let reduceNow = (halflifeReduction * (i - foundIndex - delay - (increments * whichIteration)) / increments);
        reduced = alreadyReduced + reduceNow;
    }
    return reduced;
}


function perHour(origType, readingArray, delay, intervalMinutes) {
    const incrementsPerHour = 60 / intervalMinutes;
    let first = 0;
    let prev = 0;
    let reduced = (origType.reductionPerHour / incrementsPerHour);

    for (let i = 0; i < readingArray.length; i++) {
        if (first === 0 && readingArray[i][origType.name] > 0) {
            first = i;
            prev = readingArray[i][origType.name];
            continue;
        } else if (readingArray[i][origType.name] > 0) {
            prev += readingArray[i][origType.name];
        } else if (delay > i - first) {
            readingArray[i][origType.name] = prev;
            continue;
        } else if (first === 0 && readingArray[i][origType.name] === 0) {
            continue;
        }

        readingArray[i][origType.name] = prev - reduced;
        prev = readingArray[i][origType.name];
        if (readingArray[i][origType.name] <= 0 && first !== 0) {
            readingArray[i][origType.name] = 0;
            first = 0;
        }
    }
}

function createIncrementedArrayForRange(origType, intervalMinutes, fromDate, toDate) {
    // Get data in a better format for a graph, i.e. regular intervals on X-axis
    const readingArray = [];
    let currentDateString = fromDate.replaceAll('-', '/');
    toDate = toDate.replaceAll('-', '/');
    let currentDate = new Date(currentDateString);
    let simpleTime = 0;
    let simpleTimeToday = 0;
    let dayNumber = 0;
    while (currentDateString <= toDate) {
        let year = currentDate.getFullYear();
        let month = currentDate.getMonth() + 1;
        let day = currentDate.getDate();
        let simpleDate = month + '/' + day;
        for (let i = 0; i < 1440 / intervalMinutes; i++) {
            simpleTimeToday = intervalMinutes * i;
            let simpleTotalMinutes = simpleTime + simpleTimeToday + (dayNumber * 60);
            let simpleHours = Math.floor(simpleTimeToday / 60);
            let simpleMinutes = simpleTimeToday % 60;
            let simpleCombinedDateTime = simpleDate + ' ' + simpleHours + ':' + simpleMinutes;
            readingArray.push({[origType.name]: 0, minutes: simpleTotalMinutes, dateTime: simpleCombinedDateTime});
        }
        day++;
        if (day === 32) {
            if (month === 12) {
                month = '01';
                year++;
            } else {
                month = ('0' + (month + 1)).slice(-2);
            }
            day = '01';
        }
        currentDateString = year + '/' + ('0' + month).slice(-2) + '/' + ('0' + day).slice(-2);
        currentDate = new Date(currentDateString);
        simpleTime += simpleTimeToday;
        dayNumber++;
    }
    return readingArray;
}

function addDelay(origType, intervalMinutes) {
    let delay = 0;
    if (origType.reductionDelay > 0) {
        // Add a delay
        delay = Math.round(origType.reductionDelay / intervalMinutes);
    }
    return delay;
}


